<div class="d-flex flex-column justify-content-center align-items-center">
    <h3 style="color: #004F71">Import Legacy Items</h3>
    <form [formGroup]="form" class="component-form">
        <mat-form-field class="tag-chip-field" appearance="outline">
            <mat-label>Import Legacy Items</mat-label>
            <mat-chip-grid #chipGrid aria-label="Selected tags">
                @for (tag of selectedTags; track tag) {
                    <mat-chip-row class="tag-chip" (removed)="removeTag(tag)">
                        {{ tag }}
                        <button matChipRemove aria-label="Remove {{ tag }}">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                }
            </mat-chip-grid>
            <input
                #tagInputRef
                placeholder="Type or paste comma-separated tags…"
                [formControlName]="'tagInput'"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matAutocomplete]="auto"
                (matChipInputTokenEnd)="addTagFromInput($event)"
                (paste)="onPaste($event)" />

            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                @for (item of filteredLegacyItems$ | async; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                }
                @if ((filteredLegacyItems$ | async)?.length === 0) {
                    <mat-option disabled>No matching legacy items</mat-option>
                }
            </mat-autocomplete>

            @for (tag of tagsNotInManagement; track tag) {
                <mat-error>{{ tag }} does not exist in Management</mat-error>
            }
            @for (tag of tagsAlreadyInCommonItems; track tag) {
                <mat-error>{{ tag }} already exists in the Common Items list</mat-error>
            }
        </mat-form-field>
        @if (rejectedPasteTags.length > 0) {
            <p class="rejected-tags-message">
                <strong>The following tags were not added because they are not valid legacy items or they already exist as common items:
                {{ rejectedPasteTags.join(', ') }}</strong>
            </p>
        }
    </form>
    <div mat-dialog-actions class="buttons-offset">
        <button mat-raised-button class="button-text-color" (click)="close()">Cancel</button>
        <button mat-raised-button class="button-text-color" (click)="import()" [disabled]="!canImport">
            <mat-icon aria-hidden="true" class="button-text-color">file_download</mat-icon>
            Import
        </button>
    </div>
</div>
